<template>
  <div class="englobe-params">
    <div class="params-row">
      <!-- Back to index -->
      <GoBackButton path="/questions" />

      <div
        v-if="store.previousQuestionID || store.nextQuestionID"
        class="previous-next-wrapper"
      >
        <RouterLink
          v-if="store.previousQuestionID"
          v-focus
          :to="`/questions/${store.previousQuestionID}`"
          class="btn-primary previous"
        >
          <i class="fa-solid fa-chevron-left" />Précédente
        </RouterLink>
        <RouterLink
          v-if="store.nextQuestionID"
          v-focus
          :to="`/questions/${store.nextQuestionID}`"
          class="btn-primary next"
        >
          Suivante<i class="fa-solid fa-chevron-right" />
        </RouterLink>
      </div>
    </div>
  </div>
</template>

<script setup>
import GoBackButton from "@follaw-fr/components/general/atoms/GoBackButton.vue";
import { useQuestionsStore } from "@follaw-fr/stores/questions";

const store = useQuestionsStore();
</script>
